declare let gift_card_object: any;

export default function setGiftCard(elButton: string) { 

    const btns = document.querySelectorAll(elButton);

    btns?.forEach((el: any, index: any) => {

        el?.addEventListener("click", function(e){
            e.preventDefault();

            const elBtn = e.currentTarget as HTMLButtonElement;

            const elLoading = elBtn?.querySelector('.fa-circle-notch');

            elLoading?.classList.remove('hidden');

            // Get card id
            const cardId = elBtn?.dataset.card;

            if(typeof cardId !== 'undefined'){

                localStorage.setItem('gift-card', cardId);

                // Go to order page
                location.replace(gift_card_object.page_order);

            }

        });
        
    });

}